import React from "react";

// Scalable SVG panda mascot. Props: size, accessory, scarf, item, className, animate
const Panda = ({ size = 200, accessory = "none", scarf = "#e5356f", item = "none", className = "", animate = false }) => {
  return (
    <svg
      viewBox="0 0 200 230"
      width={size}
      height={size * 1.15}
      className={`${className} ${animate ? "panda-bounce" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Panda mascot"
      role="img"
    >
      {/* legs */}
      <ellipse cx="70" cy="208" rx="22" ry="14" fill="#1f1f1f" />
      <ellipse cx="130" cy="208" rx="22" ry="14" fill="#1f1f1f" />
      {/* body */}
      <ellipse cx="100" cy="168" rx="52" ry="44" fill="#ffffff" stroke="#1f1f1f" strokeWidth="3" />
      {/* arms */}
      <ellipse cx="52" cy="160" rx="16" ry="26" fill="#1f1f1f" transform="rotate(20 52 160)" />
      <ellipse cx="148" cy="160" rx="16" ry="26" fill="#1f1f1f" transform="rotate(-20 148 160)" />
      {/* belly */}
      <ellipse cx="100" cy="176" rx="30" ry="24" fill="#f4f4f4" />
      {/* item held */}
      {item === "coin" && (
        <g>
          <circle cx="100" cy="170" r="20" fill="#f3c932" stroke="#c9a01c" strokeWidth="3" />
          <circle cx="100" cy="170" r="14" fill="none" stroke="#c9a01c" strokeWidth="2" />
          <text x="100" y="177" textAnchor="middle" fontSize="20" fontWeight="800" fill="#8a6d00" fontFamily="Work Sans, sans-serif">$</text>
        </g>
      )}
      {item === "card" && (
        <g transform="rotate(-8 100 172)">
          <rect x="72" y="158" width="56" height="34" rx="5" fill="#1b8bc9" stroke="#0f5f8c" strokeWidth="2" />
          <rect x="72" y="166" width="56" height="7" fill="#0f5f8c" />
          <rect x="78" y="180" width="22" height="5" rx="2" fill="#ffffff" opacity="0.9" />
        </g>
      )}
      {item === "bamboo" && (
        <g transform="rotate(25 100 170)">
          <rect x="96" y="120" width="9" height="90" rx="4" fill="#63c79a" stroke="#2e8b57" strokeWidth="2" />
          <line x1="96" y1="145" x2="105" y2="145" stroke="#2e8b57" strokeWidth="2" />
          <line x1="96" y1="175" x2="105" y2="175" stroke="#2e8b57" strokeWidth="2" />
          <ellipse cx="112" cy="130" rx="12" ry="5" fill="#63c79a" transform="rotate(-30 112 130)" />
        </g>
      )}
      {/* scarf */}
      <path d="M52 132 Q100 158 148 132 L148 146 Q100 172 52 146 Z" fill={scarf} />
      <path d="M118 145 L132 190 L146 182 L130 140 Z" fill={scarf} />
      {/* ears */}
      <circle cx="50" cy="48" r="20" fill="#1f1f1f" />
      <circle cx="150" cy="48" r="20" fill="#1f1f1f" />
      {/* head */}
      <circle cx="100" cy="90" r="60" fill="#ffffff" stroke="#1f1f1f" strokeWidth="3" />
      {/* eye patches */}
      <ellipse cx="74" cy="90" rx="15" ry="19" fill="#1f1f1f" transform="rotate(-15 74 90)" />
      <ellipse cx="126" cy="90" rx="15" ry="19" fill="#1f1f1f" transform="rotate(15 126 90)" />
      {/* eyes */}
      <circle cx="77" cy="90" r="7" fill="#ffffff" />
      <circle cx="123" cy="90" r="7" fill="#ffffff" />
      <circle cx="79" cy="91" r="3.5" fill="#1f1f1f" />
      <circle cx="121" cy="91" r="3.5" fill="#1f1f1f" />
      <circle cx="80" cy="89" r="1.2" fill="#fff" />
      <circle cx="122" cy="89" r="1.2" fill="#fff" />
      {/* cheeks */}
      <circle cx="62" cy="112" r="7" fill="#f9a8c9" opacity="0.7" />
      <circle cx="138" cy="112" r="7" fill="#f9a8c9" opacity="0.7" />
      {/* nose & mouth */}
      <ellipse cx="100" cy="110" rx="7" ry="5" fill="#1f1f1f" />
      <path d="M100 115 Q100 124 92 124 M100 115 Q100 124 108 124" stroke="#1f1f1f" strokeWidth="2.5" fill="none" strokeLinecap="round" />

      {/* accessories */}
      {accessory === "glasses" && (
        <g fill="none" stroke="#1b8bc9" strokeWidth="4">
          <circle cx="75" cy="90" r="20" />
          <circle cx="125" cy="90" r="20" />
          <line x1="95" y1="90" x2="105" y2="90" />
          <line x1="55" y1="86" x2="44" y2="78" />
          <line x1="145" y1="86" x2="156" y2="78" />
        </g>
      )}
      {accessory === "bowtie" && (
        <g>
          <path d="M84 142 L100 150 L84 158 Z" fill="#e5356f" stroke="#a81f4e" strokeWidth="2" />
          <path d="M116 142 L100 150 L116 158 Z" fill="#e5356f" stroke="#a81f4e" strokeWidth="2" />
          <circle cx="100" cy="150" r="4" fill="#a81f4e" />
        </g>
      )}
      {accessory === "hat" && (
        <g>
          <path d="M100 -2 L74 44 L126 44 Z" fill="#f7931e" stroke="#c26a00" strokeWidth="2" />
          <path d="M84 26 L116 26" stroke="#fff" strokeWidth="4" strokeDasharray="6 6" />
          <circle cx="100" cy="0" r="6" fill="#e5356f" />
        </g>
      )}
      {accessory === "crown" && (
        <g>
          <path d="M70 42 L70 14 L84 30 L100 6 L116 30 L130 14 L130 42 Z" fill="#f3c932" stroke="#c9a01c" strokeWidth="2" />
          <circle cx="100" cy="32" r="4" fill="#e5356f" />
          <circle cx="80" cy="34" r="3" fill="#1b8bc9" />
          <circle cx="120" cy="34" r="3" fill="#1b8bc9" />
        </g>
      )}
      {accessory === "cap" && (
        <g>
          <path d="M60 40 L100 22 L140 40 L100 58 Z" fill="#1f1f1f" />
          <path d="M72 44 L72 56 Q100 70 128 56 L128 44" fill="#333" />
          <line x1="140" y1="40" x2="144" y2="66" stroke="#f3c932" strokeWidth="3" />
          <circle cx="144" cy="68" r="4" fill="#f3c932" />
        </g>
      )}
    </svg>
  );
};

export default Panda;
